import { IAddress } from '@grc/ui-shared';
import {
  BusinessEntityType,
  CommunicationType,
  Country,
  PhoneType,
  TransportStatus
} from '@grc/ui-shared/lib/components/models/enums/enums';
import { countries } from '@grc/ui-shared/lib/components/common/constants/constants';

export { TransportStatus };

export const headerPopoverWidth = '300px';
export const rejectedloads = 'rejectedloads';
export const upcomingloads = 'upcomingloads';
export const intransit = 'intransit';
export const totalloads = 'totalloads';
export const ftlloads = 'ftlloads';
export const ltlloads = 'ltlloads';
export const delivered = 'delivered';
export const emptyPhoneNumber = '+1 (123) 456-7890';
export const testAccountId = 'b677651f-fe63-4e77-930f-241622388172'; // TODO : In future Details getting from auth0 token

export const generateRandomAlphanumeric = () => {
  return Math.random().toString(36).substring(2, 10).toUpperCase();
};

export const importActions = [
  { id: 1, text: 'PDF' },
  { id: 2, text: 'Excel' },
  { id: 3, text: 'CSV' }
];

export const countryPhoneCodes = ['+1', '+44', '+91', '+86'];
export const countryPhoneNameCodes = ['US', 'UK'];
export const usCountryPhoneMask = '+1 (000) 000-0000';
export const mxnCountryPhoneMask = '+52 (00) 0000-0000';
export const canCountryPhoneMask = '+1 (000) 000-0000';

export const countryPhoneOptions = [
  { id: 'US', name: 'US', code: '+1', mask: usCountryPhoneMask },
  { id: 'MX', name: 'Mexico', code: '+52', mask: mxnCountryPhoneMask },
  { id: 'CA', name: 'Canada', code: '+1', mask: canCountryPhoneMask }
];

export const STRING_CONST = 'string';
export const US_COUNTRY_CODE = 'US';

export const communicationAddressTypes = [
  { id: PhoneType.Mobile, name: 'Mobile' },
  { id: PhoneType.Home, name: 'Home' },
  { id: PhoneType.Work, name: 'Work' },
  { id: PhoneType.Fax, name: 'Fax' },
  { id: PhoneType.Other, name: 'Other' }
];

export const auditEventTypes = [
  {
    id: 1,
    text: 'Details Changed',
    value: 'Details Changed'
  },
  {
    id: 2,
    text: 'Details Removed',
    value: 'Details Removed'
  },
  {
    id: 3,
    text: 'Exception Created',
    value: 'Exception Created'
  },
  {
    id: 4,
    text: 'Exception Updated',
    value: 'Exception Updated'
  },
  {
    id: 5,
    text: 'Exception Removed',
    value: 'Exception Removed'
  }
];

export const maskRules = { X: /[02-9]/ };

const index = countries.findIndex(
  country => country.id === Country.UnitedStates
);

export const defaultPhoneCountry = countries[index].name;

export const statusCellStylings: any = {
  'Need Update': 'warning',
  'Waiting for Pickup': 'warning',
  'Out for Delivery': 'warning',
  'Pending Pickup': 'warning',
  'Pending Delivery': 'warning',
  'In Transit': 'danger',
  'Delivered': 'success',
  'Picked Up': 'success',
  'On Time': 'success',
  'Delay': 'danger',
  'Scheduled': 'success'
};

export type BusinessEntity = {
  id: string;
  name: string;
  displayId?: string;
  address?: IAddress;
  generalPhoneNumber?: {
    phoneType: CommunicationType;
    phoneNumber: string;
    displayOrder: number;
  };
  generalEmailAddress?: string;
  entityType?: BusinessEntityType | number | string;
};
export type TransportationMode = { id: string; displayName: string };
export type ShipmentType = { id: string; shipmentTypeName: string };
export type ServiceLevel = { id: string; serviceChargeName: string };
export type EquipmentType = { id: string; equipmentTypeName: string };
export type BusinessEntityMap = Record<string, BusinessEntity>;
export type ModeMap = Record<string, TransportationMode>;
export type EquipmentMap = Record<string, EquipmentType>;
export type ShipmentTypeMap = Record<string, ShipmentType>;
export type ServiceLevelMap = Record<string, ServiceLevel>;

export type GridRow = {
  transportId: string;
  tenderId: string;
  status: string;
  source: string;
  mode: string;
  origin: string;
  destination: string;
  puDateAndTime?: string;
  deliveryDateAndTime?: string;
  plannedStart?: string;
  plannedEnd?: string;
  nextLocationUpdate?: string;
  carrierPro?: string;
  trailerNo?: string;
  noOfShipments?: number;
  quantity?: number;
  weight?: number;
};

export type ContestGridRow = {
  contestId: string;
  quoteId: string;
  quoteNumber: string;
  loadBoardNumber: string;
  bidResponses: string;
  bidResponsesDetails: any;
  bidSubmittedDateAndTime: string;
  scheduledPuDateTime: string;
  trailerType: any;
  transitDays: string;
  targetRate: string;
  postedBy: string;
  postedDateTime: string;
  comments: string;
  bidComments: string;
};

export type TenderGridRow = {
  transportId: string;
  tenderId: string;
  mode: string;
  origin: string;
  destination: string;
  carriers?: any[];
  latestCarrier?: any;
};

export type FetchTransportsFilters = {
  transportStatus?: TransportStatus;
  transportationModeId?: string | number;
};

export const locationTypesForOriginAndDestination: BusinessEntityType =
  BusinessEntityType.TenantOwned |
  BusinessEntityType.Location |
  BusinessEntityType.Hub |
  BusinessEntityType.Agent |
  BusinessEntityType.Carrier |
  BusinessEntityType.Broker |
  BusinessEntityType.BillTo;

// Equipment form constants
export const maxWeightEquipmentAttributes = {
  'aria-label': 'Max Weight by ET Unit'
};

export const maxWeightEquipmentDropDownOptions = {
  container: '#max_weight_et_select_create_new_equipment'
};

export const maxWeightCarrierAttributes = {
  'aria-label': 'Max Weight for Carrier Unit'
};

export const maxWeightCarrierDropDownOptions = {
  container: '#max_weight_carrier_select_create_new_equipment'
};

export const trailerTypeAttributes = {
  id: 'trailer_type_select_create_new_equipment'
};

export const trailerTypeDropDownOptions = {
  container: '#trailer_type_select_create_new_equipment'
};

// ---------------- check call constants ----------------------------
